import { useEffect, useRef } from "react";
import { prefillInquiry } from "./smooth";
import { useT } from "@/lib/i18n";

const SRC = "https://gochiptuningfiles.com/api/widget/embed.js";
const KEY = process.env.REACT_APP_GCF_WIDGET_KEY;
const TXT = {
  no: {
    eyebrow: "Stage 1-kalkulator", h3: "Hva kan din bil få ut?",
    p: "Søk på registreringsnummer eller velg merke, modell, generasjon og motor – og se original effekt, Stage 1-effekt, dreiemoment og effektkurve.",
    disclaimer: "Oppgitte effekt- og momentverdier er veiledende. Faktiske resultater kan variere avhengig av kjøretøyets tekniske tilstand, programvare og utstyr.",
  },
  en: {
    eyebrow: "Stage 1 calculator", h3: "What can your car deliver?",
    p: "Search by registration number or choose make, model, generation and engine – and see stock power, Stage 1 power, torque and power curve.",
    disclaimer: "Stated power and torque figures are indicative. Actual results may vary depending on the vehicle's technical condition, software and equipment.",
  },
};

const toPrefill = (e) => ({
  service: "chiptuning",
  car: { make: e?.make_name ?? "", model: e?.model_name ?? "", engine: e?.name ?? "", year: "" },
  stage1: e?.stage1_hp != null && e?.stock_hp != null
    ? `${e.stock_hp} hk / ${e.stock_tq ?? "?"} Nm → ${e.stage1_hp} hk / ${e.stage1_tq ?? "?"} Nm`
    : null,
});

export const GcfWidget = () => {
  const t = useT(TXT);
  const ref = useRef(null);
  const engine = useRef(null);

  useEffect(() => {
    const box = ref.current;
    if (!box || !KEY) return undefined;
    const onSelect = (ev) => { engine.current = ev.detail ?? null; };
    const onClick = (ev) => {
      const hit = ev.composedPath().some((n) => n?.classList?.contains("gcfw-cta"));
      if (!hit || !engine.current) return;
      ev.preventDefault();
      ev.stopPropagation();
      prefillInquiry(toPrefill(engine.current));
    };
    box.addEventListener("gcf-widget:selection", onSelect);
    box.addEventListener("click", onClick, true);
    document.querySelectorAll(`script[src="${SRC}"]`).forEach((s) => s.remove());
    const s = document.createElement("script");
    s.src = SRC;
    s.defer = true;
    s.dataset.key = KEY;
    s.dataset.target = "#gcf-widget";
    s.dataset.theme = "dark";
    s.dataset.layout = "full";
    document.body.appendChild(s);
    return () => {
      box.removeEventListener("gcf-widget:selection", onSelect);
      box.removeEventListener("click", onClick, true);
      s.remove();
    };
  }, []);

  return (
    <div className="border border-white/10 bg-[#08090b]/85 p-4 backdrop-blur-xl sm:p-6 md:p-10" data-testid="gcf-widget-card">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--red)]">{t.eyebrow}</div>
          <h3 className="mt-3 font-display text-4xl font-black uppercase leading-[0.9] md:text-5xl">{t.h3}</h3>
        </div>
        <p className="max-w-sm text-sm text-zinc-300">{t.p}</p>
      </div>
      <div id="gcf-widget" ref={ref} data-testid="gcf-widget" className="min-h-[220px]" />
      <p className="mt-6 text-xs leading-relaxed text-zinc-400" data-testid="calc-disclaimer">{t.disclaimer}</p>
    </div>
  );
};
